import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import {useSelector} from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {Box} from '@mui/material';
import {ROLES} from '../../../../../../constants/roles';
import useUser from '../../../../../../utility/hooks/useUser';

const replaceIfNotNull = (originalText, placeholder, value) => {
    if (value !== null && value !== undefined) {
        const regex = new RegExp(placeholder, 'g');
        return originalText.replace(regex, value);
    }
    return originalText;
};

const replaceParentSafely = (originalText, placeholder, value) => {
    if (value === null || value === undefined) return originalText;

    if (placeholder === '@Parent') {
        return originalText.replace(/@Parent(?!Surname)/g, value);
    }

    return originalText;
};

const RichEditorResultText = ({id, description, placeholderValues, enableValidation, error}) => {
    const {account} = useSelector(state => state.application);
    const [text, setText] = useState('');
    const theme = useTheme();
    const {user} = useUser();
    const isSchoolUser = Array.isArray(user?.roles) &&
        [ROLES.SCHOOL_ADMIN, ROLES.MEMBER_OF_STAFF, ROLES.SENIOR_MEMBER_OF_STAFF]
            .some(role => user.roles.includes(role));

    useEffect(() => {
        let resultText = description;

        if (placeholderValues) {
            resultText = replaceIfNotNull(resultText, '@ParentSurname', placeholderValues.parentSurname);
            resultText = replaceParentSafely(resultText, '@Parent', placeholderValues.parent);
            if (isSchoolUser) {
                resultText = replaceIfNotNull(resultText, '@Title', placeholderValues.title);
            } else {
                resultText = replaceIfNotNull(resultText, '@Title', placeholderValues.title || '');
            }
            resultText = replaceIfNotNull(resultText, '@SchoolName', placeholderValues.schoolName);
            resultText = replaceIfNotNull(resultText, '@StudentForename', placeholderValues.studentForename);
            resultText = replaceIfNotNull(resultText, '@StudentFullName', placeholderValues.studentFullName);
            resultText = replaceIfNotNull(resultText, '@HisHer', placeholderValues.hisHer);
            resultText = replaceIfNotNull(resultText, '@HeShe', placeholderValues.heShe);
            resultText = replaceIfNotNull(resultText, '@HimHer', placeholderValues.himHer);
            resultText = replaceIfNotNull(resultText, '@Employee', placeholderValues.employee);
        }

        setText(DOMPurify.sanitize(resultText));
    }, [id, account, placeholderValues]);

    return (
        <div
            style={{
                alignItems: 'center',
                paddingBottom: '12px',
            }}
        >
            <Box
                sx={{
                    ...theme.typography.body1,
                    color: theme.palette.text.primary,
                }}
            >
                <span dangerouslySetInnerHTML={{__html: text}}/>
                {enableValidation &&
                <Box
                    component="span"
                    color={error ? theme.palette.error.main : theme.palette.text.primary}
                    style={{
                        alignSelf: 'flex-start',
                        marginLeft: 5
                    }}
                >*</Box>
                }
            </Box>
        </div>

    );
};

RichEditorResultText.defaultProps = {
    error: false
};

RichEditorResultText.propTypes = {
    id: PropTypes.string,
    description: PropTypes.string.isRequired,
    readonly: PropTypes.bool.isRequired,
    placeholderValues: PropTypes.object.isRequired,
    enableValidation: PropTypes.bool.isRequired,
    error: PropTypes.bool,
};

export default RichEditorResultText;